import React from "react";
import { ToastContainer } from "react-toastify";

import BroadcastIndex from "./BroadcastIndex";
import SetupModal from "../MarketingSettings/SetupModal";

const BroadcastIndexContainer = ({ lastTouchedVenueOwnership, sendDomains, ...props }) => (
  <>
    <SetupModal venueOwnership={lastTouchedVenueOwnership} sendDomains={sendDomains} />
    <ToastContainer icon={false} />
    <BroadcastIndex {...props} />
  </>
);

export default BroadcastIndexContainer;
